import { ReactNode } from 'react';
import cx from 'classnames';

import { Card } from '../card';
import { Heading } from '../heading';

export interface EmptyStateProps {
  /** An outline icon, 24px; drawn in a round grey badge. */
  icon?: ReactNode;
  /** With a title this is the full empty state; without one, a single quiet line. */
  title?: string;
  /** The one thing to do next — a `Button`. */
  action?: ReactNode;
  className?: string;
  /** The explanation under the title. */
  children?: ReactNode;
}

/** What a list shows instead of its rows: nothing found, nothing yet. */
export const EmptyState = ({ icon, title, action, className, children }: EmptyStateProps) => {
  if (!title) {
    return <Card className={cx('text-center text-body-s text-ink-muted', className)}>{children}</Card>;
  }

  return (
    <Card padding="lg" className={cx('flex flex-col items-center text-center', className)}>
      {icon && (
        <span className="mb-4 flex size-12 items-center justify-center rounded-full bg-surface-muted text-ink-muted">
          {icon}
        </span>
      )}
      <Heading size="sm" as="h3">
        {title}
      </Heading>
      {children && <p className="mt-2 max-w-xs text-body-s text-ink-muted">{children}</p>}
      {action && <div className="mt-5">{action}</div>}
    </Card>
  );
};
